import { frontendURL } from '../../../helper/URLHelper';
import TrashIndex from './pages/TrashIndex.vue';

// Sante-CRM: Lixeira (soft delete) — exclusiva de administradores
export const routes = [
  {
    path: frontendURL('accounts/:accountId/trash'),
    name: 'trash_index',
    component: TrashIndex,
    meta: {
      permissions: ['administrator'],
    },
  },
];
